<p-fieldset legend="Add Tool">
  <form [formGroup]="addToolFormGroup" (ngSubmit)="onSubmit()">
      <p-tabs value="0">
                    <p-tablist>
                        <p-tab value="0">Tool Settings</p-tab>
                        <p-tab value="1">Privacy</p-tab>
                        <p-tab value="2">Customizations</p-tab>
                    </p-tablist>
                    <p-tabpanels>
                        <p-tabpanel value="0">
                            <div class="flex flex-column gap-3">
                            <div class="flex flex-column gap-1">
                            <p-floatlabel variant="in">
                                    <input pInputText id="name" formControlName="name" autocomplete="off" class="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': addToolFormGroup.get('name')?.invalid && addToolFormGroup.get('name')?.touched}"/>
                                    <label for="name">Tool Name</label>
                            </p-floatlabel>
                            @if (addToolFormGroup.get('name')?.invalid && addToolFormGroup.get('name')?.touched) {
                              @if (addToolFormGroup.get('name')?.errors?.['required']) {
                                <small class="text-red-500">Tool Name is required.</small>
                              } @else if (addToolFormGroup.get('name')?.errors?.['minlength']) {
                                <small class="text-red-500">Tool Name must be at least 5 characters.</small>
                              } @else if (addToolFormGroup.get('name')?.errors?.['maxlength']) {
                                <small class="text-red-500">Tool Name must not exceed 150 characters.</small>
                              }
                            }
                            </div>
                            <p-floatlabel variant="in">
                                    <input pInputText id="description" formControlName="description" autocomplete="off" class="w-full"/>
                                    <label for="description">Tool Description</label>
                            </p-floatlabel>
                            <div class="flex flex-column gap-1">
                            <p-floatlabel variant="in">
                                    <input pInputText id="initiateLoginURL" formControlName="initiateLoginURL" autocomplete="off" class="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': addToolFormGroup.get('initiateLoginURL')?.invalid && addToolFormGroup.get('initiateLoginURL')?.touched}"/>
                                    <label for="initiateLoginURL">Initiate Login URL</label>
                            </p-floatlabel>
                            @if (addToolFormGroup.get('initiateLoginURL')?.invalid && addToolFormGroup.get('initiateLoginURL')?.touched) {
                              @if (addToolFormGroup.get('initiateLoginURL')?.errors?.['required']) {
                                <small class="text-red-500">Initiate Login URL is required.</small>
                              } @else if (addToolFormGroup.get('toolURL')?.errors?.['pattern']) {
                                <small class="text-red-500">Must be a valid URL starting with http:// or https://</small>
                              }
                            }
                            </div>
                            <div class="flex flex-column gap-1">
                            <p-floatlabel variant="in">
                                    <input pInputText id="toolURL" formControlName="toolURL" autocomplete="off" class="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': addToolFormGroup.get('toolURL')?.invalid && addToolFormGroup.get('toolURL')?.touched}"/>
                                    <label for="toolURL">Tool URL</label>
                            </p-floatlabel>
                            @if (addToolFormGroup.get('toolURL')?.invalid && addToolFormGroup.get('toolURL')?.touched) {
                              @if (addToolFormGroup.get('toolURL')?.errors?.['required']) {
                                <small class="text-red-500">Tool URL is required.</small>
                              } @else if (addToolFormGroup.get('toolURL')?.errors?.['pattern']) {
                                <small class="text-red-500">Must be a valid URL starting with http:// or https://</small>
                              }
                            }
                            </div>
                            <p-floatlabel variant="in">
                                    <input pInputText id="ltiVersion" formControlName="ltiVersion" autocomplete="off" class="w-full" readonly/>
                                    <label for="ltiVersion">LTI Version</label>
                            </p-floatlabel>
                            <div class="flex flex-column gap-1">
                            <p-floatlabel variant="in">
                                    <input pInputText id="publicKeysetURL" formControlName="publicKeysetURL" autocomplete="off" class="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': addToolFormGroup.get('publicKeysetURL')?.invalid && addToolFormGroup.get('publicKeysetURL')?.touched}"/>
                                    <label for="publicKeysetURL">Public Keyset URL</label>
                            </p-floatlabel>
                            @if (addToolFormGroup.get('publicKeysetURL')?.invalid && addToolFormGroup.get('publicKeysetURL')?.touched) {
                              @if (addToolFormGroup.get('publicKeysetURL')?.errors?.['required']) {
                                <small class="text-red-500">Public Keyset URL is required.</small>
                              } @else if (addToolFormGroup.get('publicKeysetURL')?.errors?.['pattern']) {
                                <small class="text-red-500">Must be a valid URL starting with http:// or https://</small>
                              }
                            }
                            </div>
                            <div class="flex flex-column gap-1">
                            <p-floatlabel variant="in">
                                    <input pInputText id="redirectURL" formControlName="redirectURIs" autocomplete="off" class="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': addToolFormGroup.get('redirectURIs')?.invalid && addToolFormGroup.get('redirectURIs')?.touched}"/>
                                    <label for="redirectURL">Redirect URI(s) (coma seperated)</label>
                            </p-floatlabel>
                            @if (addToolFormGroup.get('redirectURL')?.invalid && addToolFormGroup.get('redirectURL')?.touched) {
                              @if (addToolFormGroup.get('redirectURL')?.errors?.['required']) {
                                <small class="text-red-500">Redirect URL is required.</small>
                              } @else if (addToolFormGroup.get('redirectURL')?.errors?.['pattern']) {
                                <small class="text-red-500">Each Redirect URI must be a valid URL starting with http:// or https:// (separate multiple with a comma or space).</small>
                              }
                            }
                            </div>
                            <p-floatlabel variant="in">
                                    <input pInputText id="customParameters" formControlName="customParameters" autocomplete="off" class="w-full"/>
                                    <label for="customParameters">Custom Paramters</label>
                            </p-floatlabel>
                            <p-floatlabel variant="in">
                                    <p-select id="launchContainer" [options]="launchContainerOptions" formControlName="launchContainer"
                                    class="w-full" inputId="launchContainer"></p-select>
                                    <label for="launchContainer">Launch Container</label>
                            </p-floatlabel>
                            <div class="flex align-items-center gap-2">
                                    <label for="supportsDeepLinking">Supports Deeplinking</label>
                                    <p-toggleswitch formControlName="supportsDeepLinking" inputId="supportsDeepLinking" />
                            </div>
                            <div class="flex flex-column gap-1">
                            <p-floatlabel variant="in">
                                    <input pInputText id="deeplinkingURL" formControlName="deeplinkingURL" autocomplete="off" class="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': addToolFormGroup.get('deeplinkingURL')?.invalid && addToolFormGroup.get('deeplinkingURL')?.touched}"/>
                                    <label for="deeplinkingURL">Deeplinking URL</label>
                            </p-floatlabel>
                            @if (addToolFormGroup.get('deeplinkingURL')?.invalid && addToolFormGroup.get('deeplinkingURL')?.touched) {
                              @if (addToolFormGroup.get('deeplinkingURL')?.errors?.['required']) {
                                <small class="text-red-500">Deeplinking URL is required when Supports Deeplinking is enabled.</small>
                              } @else if (addToolFormGroup.get('deeplinkingURL')?.errors?.['pattern']) {
                                <small class="text-red-500">Must be a valid URL starting with http:// or https://</small>
                              }
                            }
                            </div>
                            <div class="flex align-items-center gap-2">
                                    <label for="isAssignmentAndGradeServiceEnabled">Enable Grading Service</label>
                                    <p-toggleswitch formControlName="isAssignmentAndGradeServiceEnabled" inputId="isAssignmentAndGradeServiceEnabled" />
                            </div>
                            <div class="flex align-items-center gap-2">
                                    <label for="isNamesAndRoleProvisioningServiceEnabled">Enable NRPS Service</label>
                                    <p-toggleswitch formControlName="isNamesAndRoleProvisioningServiceEnabled" inputId="isNamesAndRoleProvisioningServiceEnabled" />
                            </div>
                        </div>
                        </p-tabpanel>
                        <p-tabpanel value="1">
                          <div class="flex flex-column gap-3">
                              <div class="flex align-items-center gap-2">
                                    <label for="shareFirstNameWithTool">Share Learner's Full Name with Tool</label>
                                    <p-toggleswitch formControlName="isSharingFullNameOfLearnerWithToolEnabled" inputId="isSharingFullNameOfLearnerWithToolEnabled" />
                              </div>
                              <div class="flex align-items-center gap-2">
                                    <label for="shareEmailWithTool">Share Learner's Email with Tool</label>
                                    <p-toggleswitch formControlName="isSharingEmailOfLearnerWithToolEnabled" inputId="isSharingEmailOfLearnerWithToolEnabled" />
                              </div>
                          </div>
                        </p-tabpanel>
                        <p-tabpanel value="2">
                          
                            <p-floatlabel variant="in">
                                    <p-select id="targetLinkURICustomization" [options]="targetLinkURICustomizationOptions" formControlName="targetLinkURICustomization"
                                    class="w-full" inputId="targetLinkURICustomization"></p-select>
                                    <label for="targetLinkURICustomization">Target Link URI Customization</label>
                            </p-floatlabel>
                        </p-tabpanel>
                    </p-tabpanels>
      </p-tabs>
      <p-message severity="secondary"> 
        <div class="flex gap-2 justify-content-start">
            <p-button type="submit" label="Save"></p-button>
            <p-button type="reset"  label="Cancel" severity="secondary"></p-button>
        </div>
      </p-message>
    </form>
</p-fieldset>
